export default __webpack_public_path__ + "fonts/connect-promo-close-icon.svg";